export { default as HeadingA } from './HeadingA';
export { default as HeadingB } from './HeadingB';
export { default as HeadingC } from './HeadingC';
export { default as HeadingD } from './HeadingD';
export { default as HeadingE } from './HeadingE';
export { default as HeadingF } from './HeadingF';
export { default as HeadingG } from './HeadingG';

export { default as ProductContent, ProductTypes } from './ProductContent';

export { default as EditorialContent, EditorialTypes } from './EditorialContent';



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Typography/index.jsx